import { defineMessages } from 'react-intl';

type MessageKeys = 'noTeams' | 'memberCount';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		noTeams: {
			id: 'rovo-chat.view-agent.no-teams',
			defaultMessage: 'Not part of any teams',
			description: 'Message displayed when the agent is not part of any teams',
		},
		memberCount: {
			id: 'rovo-chat.view-agent.member-count',
			defaultMessage: '{count, plural, one {# member} other {# members}}',
			description: 'Message displayed for the number of members in a team',
		},
	});

export default message;
